import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import { useCredits } from '@/hooks/useCredits';
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Plus, Minus, Gift, ShoppingCart, Palette } from 'lucide-react';

export const CreditHistory = () => {
  const { transactions, loading } = useCredits();

  if (loading) {
    return (
      <div className="flex justify-center p-8">
        <div className="text-sm text-muted-foreground">Chargement...</div>
      </div>
    );
  }

  if (transactions.length === 0) {
    return (
      <div className="text-center p-8">
        <p className="text-muted-foreground">Aucune transaction trouvée</p>
      </div>
    );
  }

  const getTransactionIcon = (type: string) => {
    switch (type) {
      case 'purchase':
        return <ShoppingCart className="h-4 w-4" />;
      case 'generation':
        return <Palette className="h-4 w-4" />;
      case 'bonus':
        return <Gift className="h-4 w-4" />;
      default:
        return null;
    }
  };

  const getTransactionColor = (creditsChange: number) => {
    return creditsChange > 0 ? 'default' : 'secondary';
  };

  const getTransactionSign = (creditsChange: number) => {
    return creditsChange > 0 ? '+' : '';
  };

  return (
    <ScrollArea className="h-[400px] w-full">
      <div className="space-y-4">
        {transactions.map((transaction, index) => (
          <div key={transaction.id}>
            <div className="flex items-center justify-between space-x-4">
              <div className="flex items-center space-x-3">
                <div className="flex-shrink-0">
                  {getTransactionIcon(transaction.transaction_type)}
                </div>
                <div className="flex-1 space-y-1">
                  <p className="text-sm font-medium">
                    {transaction.description || `Transaction ${transaction.transaction_type}`}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {formatDistanceToNow(new Date(transaction.created_at), {
                      addSuffix: true,
                      locale: fr
                    })}
                  </p>
                </div>
              </div>
              
              <div className="flex items-center space-x-2">
                <Badge 
                  variant={getTransactionColor(transaction.credits_change)}
                  className="flex items-center space-x-1"
                >
                  {transaction.credits_change > 0 ? (
                    <Plus className="h-3 w-3" />
                  ) : (
                    <Minus className="h-3 w-3" />
                  )}
                  <span>
                    {getTransactionSign(transaction.credits_change)}{Math.abs(transaction.credits_change)}
                  </span>
                </Badge>
              </div>
            </div>
            
            {index < transactions.length - 1 && (
              <Separator className="mt-4" />
            )}
          </div>
        ))}
      </div>
    </ScrollArea>
  );
};